import React from "react";
import * as Icons from "lucide-react";
import { industries } from "../../mock";

const Industries = () => {
  return (
    <section id="industries" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-teal-700">Industries Served</div>
            <h2 className="mt-3 font-display font-extrabold text-slate-900 text-[34px] lg:text-[46px] leading-[1.08]">
              Powering the plants that <span className="text-gradient-brand">power India</span>
            </h2>
          </div>
          <p className="text-slate-600 text-[15.5px] max-w-md leading-relaxed">
            We supply application-specific grades — with full CoA, MSDS and regulatory documentation — to eight core sectors.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {industries.map((ind) => {
            const Icon = Icons[ind.icon] || Icons.Factory;
            return (
              <div key={ind.name} className="card-lift group bg-white rounded-2xl border border-slate-200 p-6">
                <div className="h-12 w-12 rounded-xl bg-teal-50 border border-teal-100 flex items-center justify-center group-hover:bg-teal-700 group-hover:border-teal-700 transition-colors">
                  <Icon className="h-6 w-6 text-teal-700 group-hover:text-white transition-colors" />
                </div>
                <h3 className="mt-5 font-display font-bold text-[18px] text-slate-900">{ind.name}</h3>
                <p className="mt-2 text-[13.5px] text-slate-600 leading-relaxed">{ind.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
